import { useState, type ReactNode } from 'react'
import { Button } from './ui/button.tsx'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from './ui/dialog.tsx'
import { Alert } from './ui/alert.tsx'

/**
 * Jedno místo pro potvrzení nevratných akcí, aby se formulace ani chování
 * nerozjížděly. Popis říká, co se stane, ne jen „jste si jistí".
 */
export function ConfirmDialog({
  open, onOpenChange, title, description, confirmLabel = 'Potvrdit',
  destructive = false, onConfirm,
}: {
  open: boolean
  onOpenChange: (v: boolean) => void
  title: string
  description: ReactNode
  confirmLabel?: string
  destructive?: boolean
  onConfirm: () => void | Promise<void>
}) {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function confirm() {
    setBusy(true)
    setError(null)
    try {
      await onConfirm()
      onOpenChange(false)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Akce se nepodařila')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
        {error && <Alert variant="destructive" className="mt-3">{error}</Alert>}
        <div className="mt-5 flex justify-end gap-2">
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={busy}>Zrušit</Button>
          <Button variant={destructive ? 'destructive' : 'default'} onClick={confirm} disabled={busy}>
            {busy ? 'Pracuji…' : confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
